// tslint:disable: max-line-length triple-equals jsx-key

import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { SearchBoxTaggedUsers } from './../../app/myAudit/components/SearchBoxTaggedUsers';
import Block from 'lqa-ui/lib/Components/Block';
import './styles.scss';
import { getItem } from '../../utils/localStorage';
import { useLocation } from 'react-router-dom';
import { standard } from './apiCaller';
import { assessments as assessmentApi } from '../Dashboard/apiCaller';
import LoadingContent from 'lqa-ui/lib/Components/LoadingContent/index';
import '../../style/main.scss';
import ControlTextarea from 'lqa-ui/lib/Components/ControlTextarea';
import { getLabel } from '../../enums/labels/PerformanceClassification';
import { bottomSheet } from '../../components/commons/BottomSheet';
import { Portal } from '../../components/commons/Portal';
import { OverlayAudio } from '../../components/commons/AudioPlayer/OverlayAudio';
import {
  getSelfAssessmentAttachmentForStandard,
  getSelfAssessmentAttachmentsListOfStandards,
} from '../EditSelfAssessment/apiCaller';
import { showErrorMessage } from '../../helpers/showMessage';
import { unescape } from 'lodash';
import ImageOverlay from 'lqa-ui/lib/Components/ImageOverlay';
import { StandardPerformaceSelector } from '../commons/StandardPerformanceSelector/standardPerformanceSelector';
import { isUnauthorized } from '../../utils/common';
import { gethasAssessment } from '../../helpers/handleBrandAndHotelData';
import { AppHeader } from '../../app/common/sharedComponents/AppHeader';
import { SelfAssessmentQuestionCard } from '../../app/selfAssessment/components/SelfAssessmentQuestionCard';
import { defaultScoringTypes } from '../../app/myAudit/components/QuestionCard/utils';
import { useTranslation } from 'react-i18next';
import { ButtonWithIcon } from '../../style/styled.selfAssessment';
import { Image } from '../../app/common/icons/Image';
import { Score } from '../../components/EditSelfAssessment/Score';
import {
  ScoreContainer,
  TextAreaLabel,
} from '../../components/EditSelfAssessment/EditSelfAssessment.styled';
import { IScoreValues } from '../../app/@types/pill';
import { Grid } from '../../app/common/sharedComponents/Grid';
import { GridContainer } from '../../app/common/sharedComponents/Grid/styled.grid';

const AssessmentStandarContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  height: 100vh;
  align-items: center;
  width: 100%;
`;

const ContentArea = styled.div`
  display: flex;
  flex-direction: column;
  min-height: calc(100vh - 100px);
  background-color: #fff;
  width: 100%;
  top: 85px;
  position: absolute;
  padding-bottom: 85px;
`;

const StandardAttachment = ({ standardsAttachment, templateStandardId }) => {
  return (
    <ButtonWithIcon key={templateStandardId}>
      <ImageOverlay
        images={[{ source: standardsAttachment[0].url }]}
        target={
          <span>
            <Image strokeColor="platinum" />
          </span>
        }
      />
    </ButtonWithIcon>
  );
};

const SelfAssessmentSummaryStandards = () => {
  const location = useLocation();
  const { t } = useTranslation();
  const loc: any = { ...location };
  const selectedHotel = getItem('selectedHotel');
  const selectedClient = getItem('selectedClient');
  const {
    apiData: selfAssessmentSummaryData,
    assessmentId,
    standardType,
    categoryId,
    subCategoryId,
    imgAttach,
    audioAttach,
    performanceClassificationSummary,
    duplicateCategories,
    selfAssessmentData,
    subDepartmentId,
    taggedUsers,
  } = loc.state;

  const [toggleTab, settoggleTab] = useState([true]);
  const [toggleSubTab, settoggleSubTab] = useState([true]);
  const [subCat, setSubCat] = useState<any[]>([]);
  const [Index, setIndex] = useState(1);
  const [std, setStd] = useState<
    { stats: any; items: any; eq: any; selfAssessmentComments: any } | undefined
  >(undefined);

  const [audioOverlayOpened, setAudioOverlayOpened] = useState(false);
  const [audio, setAudio] = useState<
    | {
      url: string;
      notes: string;
    }[]
    | []
  >([]);
  const [selectedAssessment, setSelectedAssessment] = useState<string | undefined>(undefined);
  const [selectedCategory, setSelectedCategory] = useState(subCategoryId);
  const [score, setScore] = useState<number | string>(0);
  const [openImage, setOpenImage] = useState(false);
  const [imageData, setImageData] = useState([]);
  const [selectedUrl, setSelectedUrl] = useState('');
  const [notes, setNotes] = useState('');
  const [open, setOpen] = useState(false);
  const [showCom, setShowCom] = useState(false);
  const [showEq, setShowEq] = useState(false);
  const [standardsAttachments, setStandardsAttachments] = useState<any>([]);
  const [roomNumber, setRoomNumber] = useState<any>(undefined);
  const [outletName, setOutletName] = useState<any>(undefined);
  const [isGridOpen, setGridOpen] = useState<boolean>(false);
  const hasAssessment = gethasAssessment();

  useEffect(() => {
    if (selectedCategory) {
      const selectedCat = selfAssessmentData.duplicateCategories.filter(
        (o) => o.templateCategoryId === selectedCategory
      );
      const room =
        selectedCat && selectedCat.length > 0 && selectedCat[0].roomNumber
          ? selectedCat[0].roomNumber
          : undefined;
      const outlet =
        selectedCat && selectedCat.length > 0 && selectedCat[0].outlet
          ? selectedCat[0].outlet
          : undefined;
      setRoomNumber(room);
      setOutletName(outlet);
    }
  }, [selectedCategory]);

  const [standards, setStandards] = useState(standardType);
  const [performanceClassification, setPerformaceClassification] = useState(
    performanceClassificationSummary ? performanceClassificationSummary : 'all'
  );

  useEffect(() => {
    if (selectedAssessment) {
      standard(
        selectedCategory,
        selectedAssessment,
        true,
        assessmentId,
        standards,
        performanceClassification
      )
        .then((response) => {
          setStd(response);
        })
        .catch((err) => {
          showErrorMessage(
            'Could not set ungraded assessment',
            !isUnauthorized(err)
          );
        });
    }
    const subCatData = selfAssessmentSummaryData.data.find(
      (o) => o.id === categoryId
    );
    const selSubCatData = subCatData.subCategory.find(
      (o) => o.id === subCategoryId
    );

    const index = selfAssessmentSummaryData.data.findIndex(
      (x) => x.id === categoryId
    );
    const indexSub = subCatData.subCategory.findIndex(
      (x) => x.id === subCategoryId
    );
    handleTabs(index);
    handleSubTabs(parseInt(`${index + 1}${indexSub}`));
    setSubCat(subCatData.subCategory);
    setIndex(index + 1);
    setScore(selSubCatData.score);
  }, []);

  useEffect(() => {
    if (selectedAssessment) {
      standard(
        selectedCategory,
        selectedAssessment,
        true,
        assessmentId,
        standards,
        performanceClassification
      ).then((response) => {
        setStd(response);
      });
    }
  }, [
    selectedCategory,
    selectedAssessment,
    performanceClassification,
    standards,
  ]);

  useEffect(() => {
    setStandardsAttachments([]);
    refreshSelfAssessmentAttachmentsListOfStandards();
  }, [selectedCategory]);

  const getStandardAttachment = (subDepartmentId, templateStandardId) => {
    getSelfAssessmentAttachmentForStandard(
      assessmentId,
      subDepartmentId,
      templateStandardId
    )
      .then((response) => {
        setStandardsAttachments((prevAttachments) => {
          return [
            ...prevAttachments,
            { subDepartmentId, templateStandardId, attachments: response },
          ];
        });
      })
      .catch((e) => { });
  };

  const refreshSelfAssessmentAttachmentsListOfStandards = () => {
    getSelfAssessmentAttachmentsListOfStandards(assessmentId, subDepartmentId)
      .then((data) => {
        data.map((item) => {
          getStandardAttachment(
            item.duplicateCategoryId,
            item.templateStandardId
          );
        });
      })
      .catch((err) => console.error(err));
  };

  useEffect(() => {
    if (hasAssessment) {
      assessmentApi()
        .then((response) => {
          if (!selectedAssessment) {
            setSelectedAssessment(response[0].stayStart);
          }
        })
        .catch((err) => console.error(err));
    } else {
      setSelectedAssessment(assessmentId);
    }
  }, []);

  const handleTabs = (index) => {
    const collapse: any = [];
    Object.keys(collapse).forEach((key) => {
      collapse[key] = false;
    });
    if (!collapse[index]) {
      collapse[index] = true;
    } else {
      if (collapse[index] == true) {
        collapse[index] = false;
      } else {
        collapse[index] = true;
      }
    }

    settoggleTab(collapse);
  };

  const handleSubTabs = (index) => {
    const collapse: any = [];
    Object.keys(collapse).forEach((key) => {
      collapse[key] = false;
    });
    if (!collapse[index]) {
      collapse[index] = true;
    } else {
      if (collapse[index] == true) {
        collapse[index] = false;
      } else {
        collapse[index] = true;
      }
    }

    settoggleSubTab(collapse);
  };

  const filterMetNotMetData = (standards) => {
    const renderedScore = (standard) => {
      if (standard.hitCount > 0) {
        return 1;
      }
      if (standard.missedCount > 0) {
        return 0;
      }
      return null;
    };
    const filteredStandards = standards.items.filter((standard) => {
      return standard.type === 'standard';
    });
    const updatedStandards = filteredStandards.map((standard) => {
      const updatedStandard = {
        question: {
          order: standard.nr - 1,
          id: standard.standardId,
          uuid: standard.standardId,
          text: standard.label,
          score: renderedScore(standard),
          performanceClassification:
            getLabel[standard.performanceClassification],
          comments: standard.comments[0],
          scoringTypeValues: defaultScoringTypes[standard.scoringTypeId],
          scoringTypeId: standard.scoringTypeId,
          templateStandardId: standard.templateStandardId,
        },
        isView: true,
        showDropdownIcon: true,
      };

      const standardWithAttachment = standardsAttachments.find(
        (standard) =>
          standard.templateStandardId ===
          updatedStandard.question.templateStandardId
      );

      if (standardWithAttachment) {
        // tslint:disable-next-line: no-string-literal
        updatedStandard.question['standardAttachment'] = (
          <StandardAttachment
            key={standard.templateStandardId}
            standardsAttachment={standardWithAttachment.attachments}
            templateStandardId={standard.templateStandardId}
          />
        );
      }

      return updatedStandard;
    });
    return updatedStandards;
  };

  const scoresColors = {
    'Met': 'verdigris',
    'Not Met': 'redCrayola',
    'N/A': 'battleShipGray',
    'Points': 'platinum',
  };

  const scoreList: IScoreValues[] =
    std &&
    std.stats &&
    std.stats.map((standard) => {
      return {
        key: standard.label,
        keyValue: standard.label,
        value: standard.countValue || standard.value,
        backgroundColor: scoresColors[standard.label],
      };
    });

  const scoreObject = {
    key: 'Score',
    keyValue: 'Score',
    value: score,
    backgroundColor: 'platinum',
  };
  if (scoreList) {
    scoreList.unshift(scoreObject);
  }

  const handleToggleGrid = () => {
    setGridOpen(!isGridOpen);
  };

  const convertTaggedUsersInitialState = (users) => {
    const taggedUsersInitialState =
      users && users.length > 0
        ? users.map((taggedUser) => ({
          id: taggedUser.userId,
          text: `${taggedUser.userFirstName} ${taggedUser.userLastName}`,
        }))
        : [];
    return taggedUsersInitialState;
  };

  return (
    <AssessmentStandarContainer>
      <div className="header">
        <AppHeader title={t('COMMON.SELF_ASSESSMENT.TITLES.SELF_ASSESSMENT')} />
      </div>
      {!selectedAssessment && standardsAttachments.length === 0 ? (
        <LoadingContent />
      ) : (
        <ContentArea>
          <Block className="stdcontainer">
            <div className="d-block clear-both">
              <StandardPerformaceSelector
                standard={standards}
                setStandard={setStandards}
                selectedHotel={selectedHotel}
                selectedClient={selectedClient}
                selectedAssessment={selectedAssessment}
                performanceClassification={performanceClassification}
                setPerformaceClassification={setPerformaceClassification}
                isSelf={true}
              />
            </div>

            <ScoreContainer>
              {scoreList && <Score scoreList={scoreList} />}
            </ScoreContainer>

            <GridContainer>
              <Grid
                media={[...imgAttach, ...audioAttach]}
                isGridOpen={isGridOpen}
                handleOpenGrid={handleToggleGrid}
                isView={true}
              />
            </GridContainer>

            <div className="tabs mt-20">
              <ul className="tabs-ul">
                {selfAssessmentSummaryData.data.map((tab, index) => (
                  <li
                    onClick={() => {
                      handleTabs(index);
                      handleSubTabs(parseInt(`${index + 1}${0}`));
                      setSubCat(tab.subCategory);
                      setSelectedCategory(tab.subCategory[0].id);
                      setIndex(index + 1);
                      setScore(tab.subCategory[0].score);
                    }}
                    className={`${toggleTab[index] ? 'activeTab' : ''
                      }  f-15 lh-20`}
                  >
                    {tab.name}
                  </li>
                ))}
              </ul>
              <div className="tabContainer">
                {selfAssessmentSummaryData.data.map((category, index) => (
                  <div
                    id={index}
                    className={`tabContent ${toggleTab[index] ? 'active' : ''}`}
                  >
                    <div className="subTabs">
                      <ul className="subTabs-ul">
                        {subCat &&
                          subCat.map((subCategory, index) => (
                            <li
                              onClick={() => {
                                handleSubTabs(`${Index}${index}`);
                                setSelectedCategory(subCategory.id);
                                setScore(subCategory.score);
                              }}
                              className={`${toggleSubTab[parseInt(`${Index}${index}`)]
                                  ? 'activeSubTab fw-400'
                                  : 'fw-600'
                                }  f-10 lh-12`}
                            >
                              {subCategory.name} - Standards
                            </li>
                          ))}
                      </ul>
                      <div className="subTabContainer">
                        {category.subCategory.map((sub, i) => (
                          <div
                            className={`tabContent ${toggleSubTab[parseInt(`${index + 1}${i}`)]
                                ? 'active'
                                : ''
                              }`}
                          >
                            <div>
                              {std ? (
                                std.items.length > 0 ? (
                                  filterMetNotMetData(std).map((itm) => {
                                    if (itm.type !== 'standard') {
                                      return (
                                        <SelfAssessmentQuestionCard
                                          key={itm.id}
                                          question={{
                                            ...itm.question,
                                          }}
                                          showDropdownIcon={
                                            itm.showDropdownIcon
                                          }
                                          isView={itm.isView}
                                        />
                                      );
                                    }
                                    return;
                                  })
                                ) : (
                                  <h2 className="p-10px text-center">
                                    No Standards under selected Benchmark or
                                    Performance Classification
                                  </h2>
                                )
                              ) : (
                                <LoadingContent />
                              )}
                              <TextAreaLabel>
                                Self-Assessment Comment
                              </TextAreaLabel>
                              <ControlTextarea
                                minRows={2}
                                style={{
                                  height: '81px !important',
                                  overflow: 'hidden !important',
                                  outline: 'none !important',
                                  color: '#1F1F1F !important',
                                  border: '1px solid #D9D9D9 !important',
                                  borderRadius: '0.5rem !important',
                                  padding: '12px 16px !important',
                                  backgroundColor: '#FFFFFF !important',
                                  fontSize: '13px !important',
                                  fontFamily: 'Source Sans Pro !important',
                                  marginBottom: '16px',
                                }}
                                value={
                                  std &&
                                    std.selfAssessmentComments &&
                                    std.selfAssessmentComments[0]
                                    ? unescape(std.selfAssessmentComments[0])
                                    : ''
                                }
                                disabled={true}
                              />
                              {duplicateCategories &&
                                duplicateCategories.filter((item) => {
                                  const templateCategory = subCat.find(
                                    (cat) => cat.id === selectedCategory
                                  );
                                  const templateCategoryId = templateCategory
                                    ? templateCategory.id
                                    : selectedCategory;
                                  return (
                                    item.templateCategoryId ===
                                    templateCategoryId
                                  );
                                }).length > 0 && (
                                  <SearchBoxTaggedUsers
                                    disabled={true}
                                    initialState={convertTaggedUsersInitialState(
                                      taggedUsers
                                    )}
                                  />
                                )}
                              {(roomNumber || outletName) && (
                                <>
                                  <h3 className="f-15 fw-600 lh-16 font-normal sans-font mb-10">
                                    {roomNumber ? 'Room Number' : 'Outlet Name'}
                                  </h3>
                                  <ControlTextarea
                                    className="mb-10 fw-400 f-17 lh-22"
                                    minRows={2}
                                    value={roomNumber || outletName}
                                    disabled={true}
                                  />
                                </>
                              )}
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </Block>
        </ContentArea>
      )}
      {bottomSheet(
        imageData,
        openImage,
        setOpenImage,
        selectedUrl,
        setSelectedUrl,
        notes,
        setNotes
      )}
      {Portal(undefined, open, setOpen, showCom, setShowCom, showEq, setShowEq)}
      {audio.length > 0 && (
        <OverlayAudio
          isOpen={audioOverlayOpened}
          setOpen={setAudioOverlayOpened}
          audioUrls={audio}
          setAudio={setAudio}
        />
      )}
    </AssessmentStandarContainer>
  );
};

export default SelfAssessmentSummaryStandards;
